<template>
  <q-card style="min-width: 350px">
    <q-card-section>
      <div class="text-h6">Yeni Randevu</div>
    </q-card-section>

    <q-card-section class="q-pt-none">
      <q-form class="q-gutter-md">
        <!-- Customer Name -->
        <q-input
          v-model="customerName"
          filled
          label="Isim ve Soyisim"
          lazy-rules
          :rules="[(val) => (val && val.length > 0) || 'Bos olamaz']"
        />

        <!-- Appointment Date -->
        <q-input v-model="appointmentDate" filled label="Randevu Gunu">
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date v-model="appointmentDate" mask="DD-MM-YYYY">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Appointment Start Time -->
        <q-input
          v-model="appointmentStart"
          filled
          label="Randevu Baslangic Saati"
        >
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-time v-model="appointmentStart" format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Appointment End Time -->
        <q-input v-model="appointmentEnd" filled label="Randevu Bitis Saati">
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-time v-model="appointmentEnd" format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </q-form>
    </q-card-section>

    <!-- Submit Button -->
    <q-card-actions align="right" class="text-primary">
      <q-btn v-close-popup flat label="Vazgec" color="red" />
      <q-btn
        v-close-popup
        flat
        label="Kaydet"
        color="secondary"
        @click="onSubmit"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { ref, inject } from 'vue'
import axios from 'axios'
import moment from 'moment'
import * as eventNames from '../../utils/events'
import * as notify from '../../utils/notification'
export default {
  setup() {
    const $q = useQuasar()
    const emitter = inject('emitter')

    // appointment form inputs
    const customerName = ref(null)
    const appointmentDate = ref(null)
    const appointmentStart = ref(null)
    const appointmentEnd = ref(null)
    const appointmentOpt = ref([])

    return {
      customerName,
      appointmentDate,
      appointmentStart,
      appointmentEnd,
      appointmentOpt,
      onSubmit() {
        let appDate = moment(appointmentDate.value, 'DD-MM-YYYY')
        let startTime = moment(appointmentStart.value, 'HH:mm')
        let endTime = moment(appointmentEnd.value, 'HH:mm')

        appDate.set({
          hour: startTime.get('hour'),
          minute: startTime.get('minute'),
        })

        axios
          .put('/appointments/', {
            customerName: customerName.value,
            appointmentType: "INTRODUCTION",
            appointmentStart: appDate.toISOString(),
            appointmentEnd: appDate
              .set({
                hour: endTime.get('hour'),
                minute: endTime.get('minute'),
              })
              .toISOString()            
          })
          .then(() => {
            $q.notify(notify.success('Randevu olusturuldu.'))
            emitter.emit(eventNames.REFRESH_APPOINTMENTS)
          })
          .catch(() => {
            $q.notify(notify.warning('Randevu olusturulamadi.'))
          })
      },
    }
  },
}
</script>
